export const getUsersRoute = () => `/users`;
